import * as Yup from 'yup';
import BaseProductSchema from './BaseProductSchema';

/**
 * Validation schema for Bundle products
 */
const createBundleProductSchema = () => {
  const schema = Yup.object().shape({
    type: Yup.string()
      .required('Required field')
      .oneOf(['bundle'], 'Must be a bundle type'),
    ...BaseProductSchema,
    maxQuantity: Yup.number().test(
      'max-not-below-sold',
      'Cannot reduce available tickets below the number already sold',
      function (value) {
        const { purchases } = this.parent;
        // Allow 0 (unlimited) or any value >= purchases
        return (
          !purchases || value === undefined || value === 0 || value >= purchases
        );
      }
    ),
    // Bundle products have components instead of maxQuantity
    components: Yup.array(
      Yup.object().shape({
        productId: Yup.string().required('Ticket tier selection is required'),
        quantity: Yup.number()
          .required('Quantity is required')
          .min(1, 'Minimum quantity is 1')
      })
    )
      .min(1, 'At least one ticket tier must be added to the bundle')
      .required('Bundle components are required')
  });

  return schema;
};

export default createBundleProductSchema;
